import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { inject } from '@angular/core';
import { BookingChangesService } from '../_services/booking-changes.service';
import { bmxurl, getAccess } from 'src/globals';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BusyService } from '../_services/busy.service';
import { bookingsummary, cBookingsummary } from 'src/types/bookingsummary';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { users_returndata } from 'src/types/user_returndata';
import { MessageService } from 'primeng/api';
import { GlobalService } from '../_services/global.service';
import { DaysheetOrderService, daysheetorderitem } from '../_services/daysheet-order.service';
import { forkJoin, of, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-daysheetStyle1',
  templateUrl: './daysheetStyle1.component.html',
  styleUrls: ['./daysheetStyle1.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DaysheetStyle1Component implements OnInit, OnDestroy {

  //Reloads when a booking on screen is changed elsewhere in the Dashboard - the AI assistant
  //moving one, say - since the venue hub may not tell the day a booking was moved away from.
  private bookingChangesSub = inject(BookingChangesService).changes.subscribe(change => {
    if (BookingChangesService.affects(change, this.chosenDate)) {
      this.scheduleLiveRefresh();
    }
  });

  //#region Variables
  ListBookings: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  FilteredBookingResources: any[] = [];
  ListResources: any[];
  Venue: any;
  venueStartTime: any;
  venueEndTime: any;
  chosenDate: Date = new Date();
  selectedIndex: number = 0;

  //BusyService counts globally, so an unreturned busy() keeps the spinner turning over whatever
  //screen comes next. Every busy() this screen starts is counted here instead, so ngOnDestroy
  //can hand back any still outstanding when it is torn down mid-load.
  private ownedBusyCount = 0;
  defaultInterval: number = Number(localStorage.getItem("DefaultInterval")) == 0 || isNaN(Number(localStorage.getItem("DefaultInterval"))) ? 5 : Number(localStorage.getItem("DefaultInterval"));

  //A resource can carry its own day sheet interval and the venue default is only the fallback,
  //so neither grid can assume one step for the whole sheet. rowInterval is what the capacity
  //grid is drawn at - the chosen resource's - and normalInterval what the shared rows of the
  //normal view step in. Both start at the venue default and are set as each grid is built.
  rowInterval: number = this.defaultInterval;
  normalInterval: number = this.defaultInterval;

  //The normal view has its own rows, so it has its own idea of which one the clock is in.
  nowRowIndexNormal: number = -1;
  dsHTML: any;
  resourceColour: string = "#FF0000";
  bookingForResource: any[];
  basicData: any;
  horizontalOptions: any;
  justTimes: any[] = [];
  justQtys: any[] = [];
  timeArray: any[] = [];
  DateFilteredBookingResources: any[] = [];
  DFBResourcesForDate: any[] = [];
  BookingdFromResources: any[] = [];
  persistedDate: Date = new Date();

  BookingID: string = "";
  BookingDateAndTime: string = "";
  BookingPackage: string = "";
  BookingAdmissions: string = "";
  BookingAddress: string = "";
  BookingEmail: string = "";
  BookingMobile: string = "";
  BookingValue: string = "";
  Itinerary: string = "";
  Notes: string = "";
  Extras: string = "";
  Outstanding: string = "";
  thisBooking: any;
  chosenTime: any = "None";

  qtyHeader: string[] = [];
  BookingSummary: bookingsummary;

  daysheetResources: any[];
  VenueClosings: any[] = [];

  //The closing and adjustment lists as the server sends them - every entry the venue has, not
  //one day's worth - and when they were last asked for.
  private rawVenueClosings: any[] = [];
  private rawResourceClosings: any[] = [];
  private rawResourceAdjustments: any[] = [];
  private listsFetchedAt: number = 0;
  private readonly listsMaxAgeMs: number = 5 * 60 * 1000;

  //Numbers each fetch, so an answer that has been overtaken by a later one is ignored.
  private fetchSeq: number = 0;

  //Set while a live refresh is waiting to run, so a burst of booking events becomes one reload.
  private liveRefreshTimer: any = null;

  //Resource closings that touch the chosen day, as minute windows against each resource. Loaded
  //alongside the venue closings, so only refetched when the date changes.
  dayResourceClosings: any[] = [];
  //Capacity view, one entry per time row: the closing covering the chosen resource then, if any.
  timeRowClosings: any[] = [];

  //Resource adjustments touching the chosen day, loaded and windowed the same way as closings.
  dayResourceAdjustments: any[] = [];
  //Capacity view, one entry per time row: how the chosen resource is adjusted then, if at all.
  timeRowAdjustments: any[] = [];
  //The chosen resource's normal number of places. Columns past it are only there because an
  //increase somewhere in the day widened the grid.
  gridNormalCapacity: number = 0;

  bookingFromClick: any;

  //Summary pop-over state. Hovering previews a block, clicking pins it until closed.
  summaryPinned: boolean = false;
  summaryOnLeft: boolean = false;

  //Held separately so a live refresh can find the same booking again in the rebuilt grid.
  pinnedBookingId: string = null;

  //Where the clock has got to, and whether the sheet has already jumped there this visit.
  nowRowIndex: number = -1;
  //How far through that row the clock actually is, so the line lands on the minute rather than
  //on a slot boundary.
  nowPercent: number = 0;
  nowLabel: string = "";

  //Counters are the venue-side admission flow, so the admit action only belongs on the summary
  //when the venue actually uses them.
  useCounters: boolean = localStorage.getItem("UseCounters") == "true";
  private nowTimer: any = null;
  private hasScrolledToNow: boolean = false;
  cellWidthPx: number = 30;
  timeArraySegments: any[][] = [];

  /*
    One tab per resource and resource group switched on on the Daysheet Resource Order page, in
    its order (see buildTabs). A resource's tab is the capacity grid - one place per person. A
    group's tab is the grouped view - its resources side by side under the group's heading, the
    bookings written out in each. The tab decides which, so there is no switch between them.
  */
  tabs: { kind: "RESOURCE" | "GROUP", key: string, name: string, resource: any, members: any[] }[] = [];

  //Which way the open tab draws: "capacity" for a resource, "normal" for a group.
  get viewMode(): string {
    return this.tabs[this.selectedIndex]?.kind == "GROUP" ? "normal" : "capacity";
  }

  //The open group's resources, and one row per time slot holding a cell against each of them.
  normalResources: any[] = [];
  normalRows: any[] = [];

  //The Daysheet order from the Daysheet Resource Order page, which the tabs follow. Null when it
  //could not be had, and every resource then gets a tab of its own, as the sheet always did.
  daysheetOrderItems: daysheetorderitem[] = null;

  //Whether the grouped view's columns sit under a group heading, which gives its header a second
  //row. Always the case now a group has its own tab; kept so the header still draws without one.
  normalHasGroups: boolean = false;

  //The DaysheetBlockStyle venue setting: true draws each booking once, as tall as it lasts, in a
  //group's tab; false repeats it in every time slot it covers. Read each time the view is built,
  //so a change in Venue Settings shows next time the sheet draws.
  normalBlockMode: boolean = false;
  //How tall each time row is in that mode, so a booking's block can be sized from its times.
  readonly normalRowPx: number = 34;
  columnNumbers: number[] = [];
  headerFontPx: number = 12;
  private readonly fixedColumnsPx = 180;

  @ViewChild("daysheetCard") daysheetCard: ElementRef;
  timearrayfull: boolean = false;
  hubConnection: HubConnection;
  BookingDate: Date;
  PreviousHubs: string[] = [];

  scrollPosition: number = 0;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  httpResponse: any;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
  //#endregion

  constructor(private http: HttpClient, private sanitizer: DomSanitizer, private router: Router, private busyService: BusyService, private messageService: MessageService, private globalService: GlobalService, private daysheetOrder: DaysheetOrderService) {
    if (localStorage.getItem("SmartVenueID") == null) {
      this.router.navigateByUrl("/home");
    }
  }

  private markBusy() {
    this.ownedBusyCount++;
    this.busyService.busy();
  }

  //Only ever gives back what this screen took. A stray idle() used to decrement another
  //screen's count - the tab-change path calls applyResourceFilter() with no busy() of its own.
  private markIdle() {
    if (this.ownedBusyCount > 0) {
      this.ownedBusyCount--;
      this.busyService.idle();
    }
  }

  ngOnDestroy() {
    this.bookingChangesSub.unsubscribe();
    this.hubConnection?.stop();

    if (this.nowTimer != null) {
      clearInterval(this.nowTimer);
    }

    if (this.liveRefreshTimer != null) {
      clearTimeout(this.liveRefreshTimer);
    }

    //Anything still in flight is never going to call back now.
    while (this.ownedBusyCount > 0) {
      this.markIdle();
    }
  }

  ngOnInit(): void {
    if (this.VenueID == null || this.VenueID == "" || this.VenueID == 'undefined') {
      //Without the return this carried on and started a busy() the screen was never going to
      //return, leaving the spinner turning on /home.
      this.router.navigateByUrl("/home");
      return;
    }

    this.globalService.setSmallScreenMenu(false);

    //Move the now line on without reloading anything.
    this.nowTimer = setInterval(() => this.computeNowRow(), 60000);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    if (localStorage.getItem("DaysheetDate") != null && localStorage.getItem("DaysheetDate") != "") {
      this.chosenDate = new Date(localStorage.getItem("DaysheetDate")!);
      localStorage.removeItem("DaysheetDate");
    }

    if (sessionStorage["PersistedTime"] != null) {
      this.chosenDate = new Date(sessionStorage["PersistedTime"]);
    }

    let userid = localStorage.getItem("SmartUserID");

    this.markBusy();

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse = (response as users_returndata);
      if (this.httpResponse.succeeded) {
        let user = this.httpResponse.data;

        if (getAccess("DAYSHEET", user)) {
          this.AccessAllowed = true;
          this.setupHub();

          //The day itself does not depend on the venue or its resources, so it is asked for at
          //the same time rather than after them - one round trip fewer before anything draws.
          //Whichever answer lands second draws the grid: renderResourceGrid waits until it has
          //both the day and the resources.
          forkJoin({
            venue: this.http.get(bmxurl + "venue/" + this.VenueID),
            resources: this.http.get(bmxurl + "DaySheetResourceList/" + this.VenueID + "/" + "/false"),
            //Not allowed to stop the sheet drawing: without it the Normal view simply keeps its
            //old order.
            order: this.daysheetOrder.load(this.VenueID).pipe(catchError(() => of(null)))
          }).subscribe({
            next: ({ venue, resources, order }) => {
              this.daysheetOrderItems = order != null && !order.failed ? order.items : null;
              this.Venue = venue;
              this.venueStartTime = (venue as any).data.startTime;
              this.venueEndTime = (venue as any).data.endTime;
              this.ListResources = (resources as any).data;
              this.buildTabs();

              //Draws if the day has already arrived, and either way gives back the busy() that
              //started this chain - applyResourceFilter always does, in its finally.
              this.applyResourceFilter();
            },
            error: () => {
              this.markIdle();
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error loading daysheet resources' });
            }
          });

          this.fetchDaysheetData();
        }
        else {
          this.markIdle();
        }

        this.CompletedLoading = true;
      }
      else {
        this.markIdle();
      }
    }, error => {
      this.markIdle();
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting User, error:' + error.messages[0] });
    });
  }

  private setupHub() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(environment.servicestarget + "/venue/" + this.VenueID).build();
    this.hubConnection.start();
    this.subscribeToDateHub();
  }

  private subscribeToDateHub() {
    this.PreviousHubs.forEach(e => this.hubConnection.off(e));
    this.PreviousHubs = [];

    const d = this.chosenDate;
    const eventName = "bookingEvent_" + d.getFullYear() +
      ('00' + (d.getMonth() + 1)).slice(-2) +
      ('00' + d.getDate()).slice(-2);

    this.PreviousHubs.push(eventName);
    this.hubConnection.on(eventName, () => this.scheduleLiveRefresh());
  }

  //Bookings often change in bursts - a group booking, a bulk admit - and each change fires its
  //own event, which used to mean a full reload per change. The first event waits a moment and
  //the rest of the burst rides along with it, so the sheet reloads once.
  private scheduleLiveRefresh() {
    if (this.liveRefreshTimer != null) {
      return;
    }

    this.liveRefreshTimer = setTimeout(() => {
      this.liveRefreshTimer = null;
      this.fetchDaysheetData();
      const dsDiv = this.gridElement();
      if (dsDiv) dsDiv.scrollTop = this.scrollPosition;
    }, 750);
  }

  //Fetches the day, then renders. The closing and adjustment lists are not per day - they come
  //back whole and are filtered here - so they are only refetched once they are a few minutes
  //old, rather than with every date change. A closing added while the sheet is open still
  //shows, just not instantly.
  //
  //seq guards against answers arriving out of order. Clicking quickly through the dates fires
  //several requests, and an earlier one landing last used to leave the sheet showing a day
  //other than the one chosen.
  fetchDaysheetData() {
    this.markBusy();

    //A pinned summary is left alone - it is rebound to the refreshed booking once the grid has
    //been rebuilt, so someone else taking a booking does not close what you are reading.
    if (!this.summaryPinned) {
      this.bookingFromClick = null;
    }

    const seq = ++this.fetchSeq;
    const d = new Date(this.chosenDate);
    const dateStr = ('00' + d.getDate()).slice(-2) +
      ('00' + (d.getMonth() + 1)).slice(-2) +
      d.getFullYear().toString().slice(-2);

    const daysheetReq = this.http.get(bmxurl + "daysheet/" + this.VenueID + "/" + dateStr);
    const listsDue = Date.now() - this.listsFetchedAt > this.listsMaxAgeMs;

    //Claimed when asked for rather than when they arrive, so a burst of date changes asks once.
    if (listsDue) {
      this.listsFetchedAt = Date.now();
    }

    //Each list only costs its own markings if it fails. Without the catchError one failure
    //would fail the forkJoin and take the whole sheet down with it - the adjustments API in
    //particular is still being built, and until it is deployed every call to it fails.
    const lists: Observable<any> = listsDue
      ? forkJoin({
          venueClosings: this.http.get(bmxurl + "VenueClosingList/" + this.VenueID + "/false").pipe(catchError(() => of(null))),
          resourceClosings: this.http.get(bmxurl + "ResourceClosingList/" + this.VenueID + "//false").pipe(catchError(() => of(null))),
          resourceAdjustments: this.http.get(bmxurl + "ResourceReductionList/" + this.VenueID + "/false").pipe(catchError(() => of(null)))
        })
      : of(null);

    forkJoin({ daysheet: daysheetReq, lists: lists }).subscribe({
      next: ({ daysheet, lists }) => {
        //The lists are the same whatever the day, so they are kept even from an answer that has
        //been overtaken. One that failed keeps whatever was held before.
        if (lists != null) {
          if (lists.venueClosings != null) {
            this.rawVenueClosings = (lists.venueClosings as any).data ?? [];
          }

          if (lists.resourceClosings != null) {
            this.rawResourceClosings = (lists.resourceClosings as any).data ?? [];
          }

          if (lists.resourceAdjustments != null) {
            this.rawResourceAdjustments = (lists.resourceAdjustments as any).data ?? [];
          }
        }

        //Overtaken by a later fetch - that one will draw. Still gives back its own busy().
        if (seq !== this.fetchSeq) {
          this.markIdle();
          return;
        }

        this.daysheetResources = (daysheet as any).data;
        this.applyDayLists(d);
        this.applyResourceFilter();
      },
      error: () => {
        this.markIdle();

        //The lists were claimed but never arrived, so the next fetch should ask again.
        if (listsDue) {
          this.listsFetchedAt = 0;
        }

        if (seq === this.fetchSeq) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error loading daysheet' });
        }
      }
    });
  }

  //What the held lists mean for one day. Cheap - a filter over lists already in memory - so it
  //runs for every date and refresh without going back to the server.
  private applyDayLists(d: Date) {
    const startOfDay = new Date(d); startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(d);   endOfDay.setHours(23, 59, 59, 999);

    this.VenueClosings = this.rawVenueClosings
      .filter((x: any) => new Date(x.startDate) >= startOfDay && new Date(x.endDate) <= endOfDay);
    this.dayResourceClosings = this.resourceClosingsForDay(this.rawResourceClosings, d);
    this.dayResourceAdjustments = this.resourceAdjustmentsForDay(this.rawResourceAdjustments, d);
  }

  // Pure computation — no HTTP. Called on tab switch and after fetchDaysheetData.
  //The spinner is given back in the finally whatever happens. Drawing the grid reads a lot of
  //loosely typed payload - a null venue start time or a booking missing a field used to throw
  //here and strand the busy count, so the sheet sat behind a spinner that never stopped.
  applyResourceFilter() {
    try {
      this.renderResourceGrid();
    }
    catch (e) {
      console.error("Daysheet: could not draw the grid.", e);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not draw the day sheet for this date.' });
    }
    finally {
      this.markIdle();
    }
  }

  private renderResourceGrid() {
    if (!this.daysheetResources || this.ListResources == null) {
      return;
    }

    //Nothing switched on for the sheet: the page says so rather than drawing an empty grid.
    if (this.tabs.length == 0) {
      this.timeArray = [];
      this.normalRows = [];
      this.timearrayfull = true;
      return;
    }

    //selectedIndex is the chosen tab and outlives a venue change, so coming from a venue with
    //more tabs could leave it past the end of this one's.
    if (this.selectedIndex < 0 || this.selectedIndex >= this.tabs.length) {
      this.selectedIndex = 0;
    }

    const tab = this.tabs[this.selectedIndex];

    //A group's tab is the grouped view, which has rows of its own - the capacity grid is
    //emptied so nothing reads the last resource's rows as this tab's.
    if (tab.kind == "GROUP") {
      this.timeArray = [];
      this.timeArraySegments = [];
      this.buildNormalRows(tab);
      this.computeNowRow();
      this.rebindPinnedSummary();
      this.scrollToNow();
      this.timearrayfull = true;
      return;
    }

    const chosenResource = tab.resource;
    const chosenResourceId = chosenResource.resourceId;

    // Pre-compute time indices once per booking so the inner loop is pure integer comparison
    this.FilteredBookingResources = this.daysheetResources
      .filter(x => x.resourceid == chosenResourceId)
      .map(res => ({
        ...res,
        _startIdx: this.dateToMinuteIndex(res.starttime),
        _endIdx:   this.dateToMinuteIndex(res.endtime),
      }))
      .sort((a, b) => a.startTime > b.startTime ? 1 : a.startTime < b.startTime ? -1 : 0);

    const startIndex  = this.getTimeIndex(this.venueStartTime);
    const endIndex    = this.getTimeIndex(this.venueEndTime);
    //The resource's real size, the same figure the normal view uses: the day's booking data
    //carries it, and an empty day falls back to the resource list. This used to come from the
    //bookings alone, so any day without one dropped to the 30 column fallback below whatever
    //the resource actually was. That fallback is now only for a capacity nobody has set.
    const maximumQty = this.resourceCapacity(chosenResource, this.FilteredBookingResources);

    //The grid shows one resource at a time, so it simply runs at that resource's interval.
    this.rowInterval = this.intervalFor(chosenResource);

    this.qtyHeader = [];
    for (let i = 1; i < maximumQty; i++) this.qtyHeader.push(i.toString());

    //Closings and adjustments come first, one entry per row, because an increase anywhere in
    //the day decides how wide the whole grid has to be before any row is built.
    const rowStarts: number[] = [];

    for (let i = startIndex; i < endIndex; i += this.rowInterval) {
      rowStarts.push(i);
    }

    this.timeRowClosings = [];
    this.timeRowAdjustments = [];

    for (let n = 0; n < rowStarts.length; n++) {
      //first marks where each closed run begins, which is where its label is written.
      const closing = this.closingFor(chosenResourceId, rowStarts[n], this.rowInterval);
      const previousClosing = n > 0 ? this.timeRowClosings[n - 1] : null;

      this.timeRowClosings.push(closing == null ? null : {
        name: closing.name,
        first: previousClosing == null || previousClosing.window !== closing,
        window: closing
      });

      //A closed row is already fully covered, so an adjustment is not layered on top of it.
      const w = closing != null ? null : this.windowFor(this.dayResourceAdjustments, chosenResourceId, rowStarts[n], this.rowInterval);
      const previous = n > 0 ? this.timeRowAdjustments[n - 1] : null;

      this.timeRowAdjustments.push(w == null ? null : this.describeAdjustment(w, maximumQty, maximumQty, previous == null || previous.window !== w));
    }

    //An increase adds real places on the right, so the grid is as wide as the largest capacity
    //anywhere in the day, and rows without the increase show those columns as unavailable.
    //Only when the capacity is known - an unset one keeps the fixed width fallback below.
    let gridWidth = maximumQty;

    if (maximumQty > 0) {
      for (const adj of this.timeRowAdjustments) {
        if (adj != null && adj.increase && adj.newCapacity > gridWidth) {
          gridWidth = adj.newCapacity;
        }
      }
    }

    this.gridNormalCapacity = maximumQty;
    this.timeArray = [];

    for (let n = 0; n < rowStarts.length; n++) {
      const i = rowStarts[n];
      const currentTime = this.getIndexFromTime(i);
      const rowAdjustment = this.timeRowAdjustments[n];

      //The places this row actually has - more than normal where it has been increased.
      const rowPlaces = rowAdjustment != null && rowAdjustment.increase ? rowAdjustment.newCapacity : maximumQty;

      const timeRow: any[] = new Array(gridWidth).fill(null).map((_, s) => ({
        time: currentTime, qty: 0, maxQty: maximumQty,
        colour: "#FFFFFF", bookingdata: null, customer: null,
        rowQty: 0, exceeded: false, index: s, inprogress: false, closing: false,
        //Past the normal size: a bookable place added by an increase, or a column this row
        //does not have at all because the increase is at another time of day.
        extra: s >= maximumQty && s < rowPlaces,
        unavailable: s >= rowPlaces
      }));

      let timeCounter = 0;
      let rowqty = 0;

      for (const res of this.FilteredBookingResources) {
        if (i >= res._startIdx && i <= res._endIdx) {
          for (let p = 0; p < res.numofpeople; p++) {
            timeRow[timeCounter] = {
              time: currentTime, qty: res.numofpeople, maxQty: maximumQty,
              colour: res.packagecolour, bookingdata: res.bookingdata,
              customer: res.customer, rowQty: 0, exceeded: false,
              index: p, inprogress: res.inprogress, closing: false
            };
            timeCounter++;
          }
          rowqty += res.numofpeople;
        }
      }

      if (timeRow[0]) {
        timeRow[0].rowQty = rowqty;
        if (rowqty > maximumQty) timeRow[0].exceeded = true;
      }
      this.timeArray.push(timeRow);
    }

    // Fallback: no concurrent-use data — render 30 empty columns
    if (this.timeArray.length > 0 && this.timeArray[0].every(c => c.qty === 0 && c.bookingdata === null) && maximumQty === 0) {
      this.timeArray = [];
      for (let i = startIndex; i < endIndex; i += this.rowInterval) {
        const currentTime = this.getIndexFromTime(i);
        this.timeArray.push(new Array(30).fill(null).map((_, s) => ({
          time: currentTime, qty: 0, maxQty: 0,
          colour: "#FFFFFF", bookingdata: null, customer: null,
          rowQty: 0, exceeded: false, index: s, inprogress: false
        })));
      }
    }

    //Now the rows exist: where each reduction strip sits, and what each row can actually take.
    const gridColumns = this.timeArray.length > 0 && this.timeArray[0] != null ? this.timeArray[0].length : 0;

    for (let n = 0; n < this.timeArray.length; n++) {
      const adjustment = this.timeRowAdjustments[n];

      //A reduction is counted in from the right edge of the normal places, not of the grid, so
      //in a widened grid it lands clear of the unavailable columns beyond them.
      if (adjustment != null && adjustment.reduce > 0 && gridColumns > 0) {
        const normalPlaces = Math.min(maximumQty, gridColumns);

        adjustment.reduce = Math.min(adjustment.reduce, normalPlaces);
        adjustment.coverPercent = (adjustment.reduce / gridColumns) * 100;
        adjustment.coverRightPercent = ((gridColumns - normalPlaces) / gridColumns) * 100;
      }

      //What the resource can actually take in this row - nothing when closed, the adjusted
      //figure when adjusted - so Rem and the red over-capacity time follow it rather than the
      //normal size. An unknown capacity (0) keeps the old reading, as there is nothing to
      //measure against.
      const row = this.timeArray[n];

      if (row != null && row[0] != null) {
        let effective = maximumQty;

        if (this.timeRowClosings[n] != null) {
          effective = 0;
        }
        else if (adjustment != null) {
          effective = adjustment.newCapacity;
        }

        row[0].effectiveMax = effective;

        if (maximumQty > 0) {
          row[0].exceeded = row[0].rowQty > effective;
        }
      }
    }

    //A booking occupies one cell per person. Those cells are merged into a single block so the
    //name, headcount and value can be written across them.
    this.timeArraySegments = this.timeArray.map(row => this.buildSegments(row));

    //One number per block column, numbered from 1.
    this.columnNumbers = this.timeArray.length > 0 && this.timeArray[0] != null
      ? this.timeArray[0].map((_, n) => n + 1)
      : [];

    //Block widths follow the number of concurrent uses, so recalculate whenever the grid is
    //rebuilt. Deferred so the table has been laid out before it is measured.
    setTimeout(() => this.calculateLayout());

    this.computeNowRow();
    this.rebindPinnedSummary();
    this.scrollToNow();

    this.timearrayfull = true;
  }

  // O(1) — replaces the 1440-element array + indexOf
  getTimeIndex(time: string): number {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  }

  getIndexFromTime(index: number): string {
    return String(Math.floor(index / 60)).padStart(2, '0') + ':' + String(index % 60).padStart(2, '0');
  }

  private dateToMinuteIndex(dateStr: string): number {
    const d = new Date(dateStr);
    return d.getUTCHours() * 60 + d.getUTCMinutes();
  }

  //Turns closings or adjustments into minute windows for the chosen day, one per resource
  //affected - both carry the same date, time and weekday fields. Stored dates are read with the
  //UTC getters, the same as dateToMinuteIndex reads booking times: those screens write the venue
  //wall clock with a Z on the end.
  //
  //A day based entry applies on its ticked weekdays within its date range, between its start
  //and end times on each of them. Otherwise it is one continuous period from the start date and
  //time to the end date and time, so any day in the middle is covered all day.
  private windowsForDay(items: any[], day: Date, basedOnDayField: string, resourceOf: (x: any) => string): any[] {
    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayKey = day.getFullYear() * 10000 + (day.getMonth() + 1) * 100 + day.getDate();
    const windows: any[] = [];

    for (const c of items) {
      if (c == null || c.disabled || !c.startdate || !c.enddate) {
        continue;
      }

      const resourceId = resourceOf(c);
      const s = new Date(c.startdate);
      const e = new Date(c.enddate);

      if (resourceId == null || isNaN(s.getTime()) || isNaN(e.getTime())) {
        continue;
      }

      const startKey = s.getUTCFullYear() * 10000 + (s.getUTCMonth() + 1) * 100 + s.getUTCDate();
      const endKey = e.getUTCFullYear() * 10000 + (e.getUTCMonth() + 1) * 100 + e.getUTCDate();

      if (dayKey < startKey || dayKey > endKey) {
        continue;
      }

      const startMin = s.getUTCHours() * 60 + s.getUTCMinutes();
      const endMin = e.getUTCHours() * 60 + e.getUTCMinutes();
      let from: number;
      let to: number;

      if (c[basedOnDayField]) {
        if (!c[weekdays[day.getDay()]]) {
          continue;
        }

        //The same hours on every ticked day. Equal times read as the whole day, and an end
        //before the start runs on to midnight.
        from = endMin == startMin ? 0 : startMin;
        to = endMin > startMin ? endMin : 1440;
      }
      else {
        from = dayKey == startKey ? startMin : 0;
        to = dayKey == endKey ? endMin : 1440;

        //Starting and ending on the same day with no time between - read as the whole day
        //rather than as nothing.
        if (startKey == endKey && endMin <= startMin) {
          from = 0;
          to = 1440;
        }
      }

      //What the overlay says: the venue message staff wrote, or the name when that was left
      //blank, so a marked slot is never unlabelled.
      const venueMessage = (c.venuemessage ?? '').trim();

      windows.push({ item: c, resourceId: resourceId, name: c.name, label: venueMessage != '' ? venueMessage : c.name, from: from, to: to });
    }

    return windows;
  }

  private resourceClosingsForDay(closings: any[], day: Date): any[] {
    return this.windowsForDay(closings, day, 'closingbasedonday', c => c.resourceid ?? c.resourcetoclose?.resourceId);
  }

  private resourceAdjustmentsForDay(adjustments: any[], day: Date): any[] {
    return this.windowsForDay(adjustments, day, 'reductionbasedonday', a => a.resourceid ?? a.resourcetoreduce?.resourceId)
      .map(w => ({
        ...w,
        type: w.item.adjustmenttype == 'NEWCAPACITY' ? 'NEWCAPACITY' : 'REDUCEBY',
        amount: Number(w.item.adjustmentamount ?? 0)
      }));
  }

  //The window covering a resource for the slot starting at minute i and running for
  //intervalMinutes, so one that starts or ends part way through the slot still marks it. The
  //length is passed in because it is the resource's own, not one figure for the whole sheet.
  private windowFor(windows: any[], resourceId: string, i: number, intervalMinutes: number): any {
    for (const w of windows) {
      if (w.resourceId == resourceId && w.from < i + intervalMinutes && w.to > i) {
        return w;
      }
    }

    return null;
  }

  private closingFor(resourceId: string, i: number, intervalMinutes: number): any {
    return this.windowFor(this.dayResourceClosings, resourceId, i, intervalMinutes);
  }

  //The interval a resource's rows run at. The back end sends daysheetinterval on the resource;
  //anything missing, zero or nonsense falls back to the venue default rather than leaving a
  //grid with no step at all.
  private intervalFor(resource: any): number {
    const own = Number(resource?.daysheetinterval ?? resource?.daySheetInterval ?? 0);

    return own > 0 ? own : this.defaultInterval;
  }

  private gcd(a: number, b: number): number {
    while (b > 0) {
      const t = a % b;
      a = b;
      b = t;
    }

    return a;
  }

  //Minutes since midnight, or null when the sheet is not showing today and there is no now to
  //draw. Both grids ask, so they agree on what counts as today.
  private nowMinutes(): number {
    const chosen = this.chosenDate != null ? new Date(this.chosenDate) : null;
    const now = new Date();

    if (chosen == null
      || isNaN(chosen.getTime())
      || now.getDate() !== chosen.getDate()
      || now.getMonth() !== chosen.getMonth()
      || now.getFullYear() !== chosen.getFullYear()) {
      return null;
    }

    return (now.getHours() * 60) + now.getMinutes();
  }

  //What an adjustment does to a resource of the given capacity, shaped for the template. A
  //reduction covers that many places counted in from the right, out of columns across; an
  //increase cannot grow the grid, so it is flagged with a star instead. Null when the
  //adjustment leaves the capacity as it was.
  private describeAdjustment(w: any, capacity: number, columns: number, first: boolean): any {
    const change = w.type == 'NEWCAPACITY' ? capacity - w.amount : w.amount;
    const suffix = w.label ? ": " + w.label : "";

    if (change > 0) {
      const covered = Math.min(change, columns);

      return {
        window: w, first: first, increase: false,
        newCapacity: Math.max(0, capacity - change),
        reduce: covered,
        coverPercent: columns > 0 ? (covered / columns) * 100 : 0,
        coverRightPercent: 0,
        text: "Reduced by " + change + " to " + Math.max(0, capacity - change) + suffix,
        shortText: "-" + change + suffix
      };
    }

    if (change < 0) {
      return {
        window: w, first: first, increase: true,
        newCapacity: capacity - change,
        increaseBy: -change,
        reduce: 0, coverPercent: 0, coverRightPercent: 0,
        text: "Increased to " + (capacity - change) + " (normally " + capacity + ")" + suffix,
        shortText: ""
      };
    }

    return null;
  }

  editbookingpayoff(BookingID) {
    this.router.navigate(['/editbooking/' + BookingID], { queryParams: { jumpto: 'payment' } });
  }

  editbookingadmissions(BookingID) {
    this.router.navigate(['/editbooking/' + BookingID], { queryParams: { jumpto: 'admissions' } });
  }

  LightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] == "#") { col = col.slice(1); usePound = true; }
    var num = parseInt(col, 16);
    var r = Math.min(255, Math.max(0, (num >> 16) + amt));
    var b = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amt));
    var g = Math.min(255, Math.max(0, (num & 0x0000FF) + amt));
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
  }

  doScrollyStuff(event) {
    this.scrollPosition = event.target.scrollTop;
  }

  //Clicking a block pins its summary open until the user closes it. Hovering only previews.
  showBookingData(inBooking: any, event?: any) {
    if (inBooking.bookingdata == null) {
      this.bookEmptySlot();
      return;
    }

    this.summaryPinned = true;
    this.pinnedBookingId = inBooking.bookingdata.bookingid;
    this.bookingFromClick = inBooking;
    this.setSummarySide(event);
  }

  hoverBookingData(inBooking: any, event?: any) {
    if (this.summaryPinned || inBooking.bookingdata == null) {
      return;
    }

    this.bookingFromClick = inBooking;
    this.setSummarySide(event);
  }

  clearHoverBookingData() {
    if (this.summaryPinned) {
      return;
    }

    this.bookingFromClick = null;
  }

  closeSummary() {
    this.summaryPinned = false;
    this.pinnedBookingId = null;
    this.bookingFromClick = null;
  }

  //The panel floats over the grid, so it moves to whichever side the block is furthest from.
  private setSummarySide(event?: any) {
    if (event == null || event.currentTarget == null) {
      return;
    }

    let box = event.currentTarget.getBoundingClientRect();

    this.summaryOnLeft = (box.left + (box.width / 2)) > (window.innerWidth / 2);
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.calculateLayout();
  }

  //The counter screens record arrival as checkedin. Anything other than true - false, or the
  //field not being there at all - means they have not arrived.
  isArrived(bookingdata: any): boolean {
    return bookingdata != null && bookingdata.checkedin === true;
  }

  //An allergy is only worth flagging when something has actually been written about it.
  hasAllergy(bookingdata: any): boolean {
    return bookingdata != null && bookingdata.allergytext != null && bookingdata.allergytext != "";
  }

  //Marks everyone on the booking as arrived, the same call the counter and at-a-glance screens
  //make. The sheet is reloaded afterwards so the arrived bar appears.
  admitAllForBooking(bookingId: string) {
    this.markBusy();

    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + bookingId).subscribe(response => {
      this.markIdle();
      this.httpResponse = response;

      if (this.httpResponse.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Admitted', detail: "All participants have been marked as admitted for this booking." });
        this.fetchDaysheetData();
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Not Admitted', detail: this.httpResponse.messages[0] });
      }
    }, error => {
      this.markIdle();
      this.messageService.add({ severity: 'error', summary: 'Not Admitted', detail: 'An error occurred admitting this booking.' });
    })
  }

  //The other half of the same switch - marks everyone as having left, so a mistaken admit can
  //be undone from the same place it was made.
  leaveAllForBooking(bookingId: string) {
    this.markBusy();

    this.http.get(bmxurl + "BookingCheckout/" + this.VenueID + "/" + bookingId).subscribe(response => {
      this.markIdle();
      this.httpResponse = response;

      if (this.httpResponse.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Left', detail: "All participants have been marked as having left this booking." });
        this.fetchDaysheetData();
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Not Updated', detail: this.httpResponse.messages[0] });
      }
    }, error => {
      this.markIdle();
      this.messageService.add({ severity: 'error', summary: 'Not Updated', detail: 'An error occurred checking out this booking.' });
    })
  }

  //A free slot is the quickest place to start a booking from. The wizard only accepts a date,
  //so the time and lane still have to be picked - passing those through would need
  //makeabooking to read them.
  bookEmptySlot() {
    this.router.navigateByUrl("/booking/0?bookingDate=" + new Date(this.chosenDate).toJSON());
  }

  //After a refresh the grid holds new objects, so the pinned summary is matched up again by
  //booking id. If it has gone from this resource, what was on screen is left as it was rather
  //than blanking the panel.
  private rebindPinnedSummary() {
    if (!this.summaryPinned || this.pinnedBookingId == null) {
      return;
    }

    if (this.viewMode == "normal") {
      for (const row of this.normalRows) {
        for (const cell of row.cells) {
          for (const booking of cell.bookings) {
            if (booking.bookingdata != null && booking.bookingdata.bookingid === this.pinnedBookingId) {
              this.bookingFromClick = booking;
              return;
            }
          }
        }
      }

      return;
    }

    for (const row of this.timeArray) {
      for (const cell of row) {
        if (cell.bookingdata != null && cell.bookingdata.bookingid === this.pinnedBookingId) {
          this.bookingFromClick = cell;
          return;
        }
      }
    }
  }

  //Which row the clock is sitting in. Only meaningful when looking at today.
  computeNowRow() {
    if (this.timeArray == null || this.timeArray.length == 0) {
      this.nowRowIndex = -1;
      return;
    }

    let now = new Date();

    let chosen = this.chosenDate != null ? new Date(this.chosenDate) : null;

    if (chosen == null
      || isNaN(chosen.getTime())
      || now.getDate() !== chosen.getDate()
      || now.getMonth() !== chosen.getMonth()
      || now.getFullYear() !== chosen.getFullYear()) {
      this.nowRowIndex = -1;
      return;
    }

    let minutes = (now.getHours() * 60) + now.getMinutes();
    let found = -1;

    for (let i = 0; i < this.timeArray.length; i++) {
      if (this.getTimeIndex(this.timeArray[i][0].time) <= minutes) {
        found = i;
      }
      else {
        break;
      }
    }

    this.nowRowIndex = found;

    if (found < 0) {
      this.nowPercent = 0;
      this.nowLabel = "";
      return;
    }

    //A row covers rowInterval minutes, so the line sits that fraction of the way down it.
    let rowStart = this.getTimeIndex(this.timeArray[found][0].time);
    let through = (minutes - rowStart) / this.rowInterval;

    this.nowPercent = Math.max(0, Math.min(100, through * 100));
    this.nowLabel = String(now.getHours()).padStart(2, "0") + ":" + String(now.getMinutes()).padStart(2, "0");
  }

  //Bring the current time into view once per visit. Deliberately not repeated on every live
  //refresh, which would drag the view back while someone is looking elsewhere.
  private scrollToNow() {
    if (this.hasScrolledToNow || this.nowRowIndex < 0) {
      return;
    }

    setTimeout(() => {
      let container = this.gridElement();
      let row = container != null ? container.querySelector(".dsnowrow") as HTMLElement : null;

      if (container == null || row == null) {
        return;
      }

      let rowBox = row.getBoundingClientRect();
      let containerBox = container.getBoundingClientRect();

      container.scrollTop += (rowBox.top - containerBox.top) - (container.clientHeight / 3);
      this.hasScrolledToNow = true;
    });
  }

  //Package colours run from pale pink to near black, so the writing on a block flips between
  //dark and light depending on how bright that colour actually is.
  textColourFor(colour: string): string {
    if (colour == null || colour == "") {
      return "#111111";
    }

    let hex = colour.replace("#", "").trim();

    if (hex.length == 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    if (hex.length != 6 || isNaN(parseInt(hex, 16))) {
      return "#111111";
    }

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    //Rec. 709 luminance - green carries most of what the eye reads as brightness.
    let luminance = ((0.2126 * r) + (0.7152 * g) + (0.0722 * b)) / 255;

    return luminance > 0.55 ? "#111111" : "#ffffff";
  }

  //The scrolling grid, whichever view is showing.
  private gridElement(): HTMLElement {
    return document.getElementById(this.viewMode == "normal" ? "dsNormalDiv" : "dsMainDiv");
  }

  //How many people a resource takes at once. The daysheet payload carries it against each
  //booking, which is the only place it appears; a resource with an empty day falls back to what
  //the resource list says about it.
  private resourceCapacity(resource: any, bookings: any[]): number {
    if (bookings != null && bookings.length > 0 && bookings[0].concurrentuses > 0) {
      return bookings[0].concurrentuses;
    }

    return resource.concurrentUses ?? resource.concurrentuses ?? resource.maxConcurrent ?? 0;
  }

  //The grouped view, for a resource group's tab. The group's resources are drawn side by side
  //against the same time rows under the group's heading. A booking is shown in every slot it
  //occupies, the same as the capacity grid fills a cell for each of them.
  buildNormalRows(tab: { key: string, name: string, members: any[] }) {
    this.normalResources = [];
    this.normalRows = [];
    this.normalInterval = this.defaultInterval;
    this.nowRowIndexNormal = -1;

    if (!this.daysheetResources || !tab?.members?.length) {
      return;
    }

    const group = { id: tab.key, name: tab.name, size: tab.members.length };
    const columns = tab.members.map((res, at) => ({ res: res, group: group, first: at == 0, last: at == tab.members.length - 1 }));

    //Bucketed by resource so each slot only walks the bookings that could possibly be in it.
    const byResource = new Map<string, any[]>();

    for (const res of this.daysheetResources) {
      const list = byResource.get(res.resourceid) ?? [];

      list.push({
        ...res,
        _startIdx: this.dateToMinuteIndex(res.starttime),
        _endIdx: this.dateToMinuteIndex(res.endtime)
      });

      byResource.set(res.resourceid, list);
    }

    byResource.forEach(list => list.sort((a, b) => a._startIdx - b._startIdx));

    this.normalResources = columns.map(column => ({
      resourceId: column.res.resourceId,
      name: column.res.name,
      max: this.resourceCapacity(column.res, byResource.get(column.res.resourceId)),
      //Its own interval, and below it, how many of the shared rows one of its slots covers.
      interval: this.intervalFor(column.res),
      span: 1,
      //Under a group heading: the group, and where in it this column falls.
      groupId: column.group?.id ?? null,
      groupName: column.group?.name ?? "",
      groupFirst: column.first,
      groupLast: column.last,
      groupSize: column.group?.size ?? 0,
      //Set below, once the spans are known: the group's shared Start column, and the column
      //its last member is in.
      groupSpan: 1,
      groupEndIndex: -1,
      //One booking per block (the DaysheetBlockStyle venue setting): the bookings laid out down
      //the resource's whole column, and the closings, reductions, increases and now line drawn
      //over it - see layoutBlocks and markStrip.
      blocks: [],
      marks: [],
      nowTop: null
    }));

    this.normalBlockMode = localStorage.getItem("DaysheetBlockStyle") == "booking";

    this.normalHasGroups = this.normalResources.some(nr => nr.groupId != null);

    /*
      Every resource is drawn against one set of rows, so the rows step in the largest interval
      that divides all of them: a 15 minute resource beside a 30 minute one gives 15 minute rows,
      one slot of the first per row and one of the second every second row. That is what keeps
      the times lining up across the screen - every resource's slot begins on a row boundary, and
      none of them is drawn at a time it does not actually run at.

      Held to five minutes at the finest. Intervals that do not divide into each other - 7 and 5,
      say - would otherwise put the rows a minute apart and give a day several hundred of them,
      so those resources take the nearest whole number of rows instead.
    */
    let step = this.normalResources[0].interval;
    for (const nr of this.normalResources) step = this.gcd(step, nr.interval);

    this.normalInterval = Math.max(5, step);
    for (const nr of this.normalResources) {
      nr.span = Math.max(1, Math.round(nr.interval / this.normalInterval));
    }

    /*
      A group's members share one Start column, on the group's left. Its cells cover as many rows
      as the members' slots do when they all run on the same interval - the usual case, a set of
      lanes or tables - and one row each when they do not, so the time beside any member's slot
      is always there to read.
    */
    for (let n = 0; n < this.normalResources.length; n++) {
      const nr = this.normalResources[n];

      if (!nr.groupFirst) {
        continue;
      }

      const members = this.normalResources.slice(n, n + nr.groupSize);
      nr.groupSpan = members.every(m => m.span == members[0].span) ? members[0].span : 1;
      nr.groupEndIndex = n + nr.groupSize - 1;
    }

    const startIndex = this.getTimeIndex(this.venueStartTime);
    const endIndex = this.getTimeIndex(this.venueEndTime);
    const nowMinutes = this.nowMinutes();
    const totalRows = Math.ceil((endIndex - startIndex) / this.normalInterval);

    //The last cell written for each resource, so a closing or a reduction knows whether this is
    //where its label goes. The row above is no use for that now: with resources on different
    //intervals, the cell in that position up there may belong to a different slot entirely.
    const previousCells: any[] = this.normalResources.map(() => null);

    let rowIndex = 0;

    for (let i = startIndex; i < endIndex; i += this.normalInterval, rowIndex++) {
      const currentTime = this.getIndexFromTime(i);
      const cells: any[] = [];

      if (nowMinutes != null && i <= nowMinutes) {
        this.nowRowIndexNormal = rowIndex;
      }

      for (let n = 0; n < this.normalResources.length; n++) {
        const nr = this.normalResources[n];

        //Only the row a slot starts on carries a cell. The rows under it are covered by that
        //cell's rowspan, which is what puts one box beside several on a shorter interval.
        if (rowIndex % nr.span != 0) {
          cells.push({ span: 0, bookings: [] });
          continue;
        }

        const slotLength = nr.span * this.normalInterval;
        const slotEnd = i + slotLength;
        const bookings: any[] = [];
        let used = 0;

        for (const res of (byResource.get(nr.resourceId) ?? [])) {
          //Any part of the slot counts. A row used to be short enough that a booking either
          //covered its start or was not in it at all; a slot several rows deep has to take the
          //ones that begin part way down it as well.
          if (res._startIdx < slotEnd && res._endIdx >= i) {
            used += res.numofpeople;

            //Shaped like a capacity-grid cell, so the summary panel and its hover, click and
            //admit handlers all work against it unchanged - and drawn as one, in the package
            //colour with the writing in whichever of dark or light reads on it.
            bookings.push({
              time: currentTime, qty: res.numofpeople, maxQty: nr.max,
              colour: res.packagecolour, bookingdata: res.bookingdata,
              customer: res.customer, rowQty: 0, exceeded: false,
              index: 0, inprogress: res.inprogress, closing: false,
              textColour: this.textColourFor(res.packagecolour)
            });
          }
        }

        const closing = this.closingFor(nr.resourceId, i, slotLength);
        const previousCell = previousCells[n];

        //No places to count across in this view, so a reduction covers the same share of the
        //cell as it takes of the resource.
        const adjustmentWindow = closing == null ? this.windowFor(this.dayResourceAdjustments, nr.resourceId, i, slotLength) : null;
        const adjustment = adjustmentWindow == null ? null : this.describeAdjustment(adjustmentWindow, nr.max, nr.max,
          previousCell == null || previousCell.adjustment == null || previousCell.adjustment.window !== adjustmentWindow);

        //What the resource can actually take in this slot - nothing when closed, the adjusted
        //figure when adjusted - so remaining, FULL and OVER follow it. An unknown capacity (0)
        //is left alone, as before.
        const effectiveMax = closing != null ? 0 : (adjustment != null ? adjustment.newCapacity : nr.max);

        const cell = {
          resourceId: nr.resourceId,
          //Clipped where the venue closes part way through a slot, so the table stays square.
          span: Math.min(nr.span, totalRows - rowIndex),
          //This resource's own slot time, which is what the Start column beside it shows.
          time: currentTime,
          //Where the clock sits inside this slot as a percentage of it, or null when it is not
          //in this one. Per cell rather than per row, because a slot can be several rows deep.
          nowPercent: nowMinutes != null && nowMinutes >= i && nowMinutes < slotEnd
            ? ((nowMinutes - i) / slotLength) * 100
            : null,
          //The closing covering this resource in this slot, and whether this is its first slot -
          //which is where its name is written.
          closedBy: closing,
          closedFirst: closing != null && (previousCell == null || previousCell.closedBy !== closing),
          adjustment: adjustment,
          bookings: bookings,
          used: used,
          max: nr.max,
          remaining: effectiveMax - used,
          full: nr.max > 0 && used >= effectiveMax,
          exceeded: nr.max > 0 && used > effectiveMax
        };

        previousCells[n] = cell;
        cells.push(cell);

        if (this.normalBlockMode) {
          this.markStrip(nr, cell, rowIndex);
        }
      }

      //The group Start cells, written on the first member's cell where a slot starts.
      for (let n = 0; n < this.normalResources.length; n++) {
        const nr = this.normalResources[n];

        if (!nr.groupFirst) {
          continue;
        }

        const groupEnd = i + nr.groupSpan * this.normalInterval;

        cells[n].groupStart = rowIndex % nr.groupSpan != 0
          ? { span: 0 }
          : {
              span: Math.min(nr.groupSpan, totalRows - rowIndex),
              time: currentTime,
              now: nowMinutes != null && nowMinutes >= i && nowMinutes < groupEnd
            };
      }

      this.normalRows.push({ time: currentTime, cells: cells });
    }

    if (this.normalBlockMode) {
      for (const nr of this.normalResources) {
        nr.blocks = this.layoutBlocks(byResource.get(nr.resourceId) ?? [], startIndex, endIndex);
      }
    }
  }

  //Where a minute of the day sits down a resource's column in one-block-per-booking mode. Every
  //row is normalRowPx tall there, so it is a straight scale from the venue's opening time.
  private stripPx(minute: number, startIndex: number): number {
    return ((minute - startIndex) / this.normalInterval) * this.normalRowPx;
  }

  /*
    One block per booking, as tall as the booking lasts, for one resource's column.

    Bookings that overlap on the resource sit side by side rather than on top of each other. They
    are taken in start order and each goes in the first lane that has come free by then; a run of
    bookings that overlap one another shares its width between as many lanes as it needed, and
    the next run, once they have all finished, starts again at full width.

    The end time is the last minute the booking holds (10:59 for one ending at 11:00), hence the
    +1. Anything running past the venue's hours is cut at the edge of the sheet.
  */
  private layoutBlocks(bookings: any[], startIndex: number, endIndex: number): any[] {
    const items = bookings
      .filter(res => res._startIdx < endIndex && res._endIdx + 1 > startIndex)
      .map(res => ({ res: res, from: Math.max(res._startIdx, startIndex), to: Math.min(res._endIdx + 1, endIndex), lane: 0, lanes: 1 }))
      .sort((one, two) => (one.from - two.from) || (two.to - one.to));

    let run: any[] = [];
    let runEnd = -1;
    const laneEnds: number[] = [];

    const closeRun = () => {
      run.forEach(item => item.lanes = laneEnds.length);
      run = [];
      laneEnds.length = 0;
    };

    for (const item of items) {
      if (item.from >= runEnd) {
        closeRun();
      }

      let lane = laneEnds.findIndex(end => end <= item.from);

      if (lane < 0) {
        lane = laneEnds.length;
        laneEnds.push(item.to);
      }
      else {
        laneEnds[lane] = item.to;
      }

      item.lane = lane;
      run.push(item);
      runEnd = Math.max(runEnd, item.to);
    }

    closeRun();

    return items.map(item => ({
      key: (item.res.bookingdata?.bookingid ?? "") + "|" + item.from,
      top: this.stripPx(item.from, startIndex),
      height: this.stripPx(item.to, startIndex) - this.stripPx(item.from, startIndex),
      left: (item.lane * 100) / item.lanes,
      width: 100 / item.lanes,
      //Shaped like a capacity-grid cell, as the slot view's are, so hover, click and the summary
      //panel work against it unchanged.
      booking: {
        time: this.getIndexFromTime(item.from), qty: item.res.numofpeople, maxQty: 0,
        colour: item.res.packagecolour, bookingdata: item.res.bookingdata,
        customer: item.res.customer, rowQty: 0, exceeded: false,
        index: 0, inprogress: item.res.inprogress, closing: false,
        textColour: this.textColourFor(item.res.packagecolour)
      }
    }));
  }

  //What a slot puts on a resource's column in one-block-per-booking mode: a closing, a reduction
  //or an increase over the slot's height, and the now line if the clock is in it. Labels only on
  //the first slot of each, as the slot view writes them.
  private markStrip(nr: any, cell: any, rowIndex: number) {
    const top = rowIndex * this.normalRowPx;
    const height = cell.span * this.normalRowPx;

    if (cell.closedBy) {
      nr.marks.push({ kind: "closed", top: top, height: height, label: cell.closedFirst ? cell.closedBy.label : null });
    }

    if (cell.adjustment?.reduce > 0) {
      nr.marks.push({ kind: "reduced", top: top, height: height, cover: cell.adjustment.coverPercent,
        text: cell.adjustment.text, label: cell.adjustment.first ? cell.adjustment.shortText : null });
    }

    if (cell.adjustment?.increase) {
      nr.marks.push({ kind: "increased", top: top, height: height });
    }

    if (cell.nowPercent != null) {
      nr.nowTop = top + (cell.nowPercent / 100) * height;
    }
  }

  /*
    The sheet's tabs, in Daysheet order.

    Each resource switched on on the Daysheet Resource Order page gets a tab of its own, drawn
    as the capacity grid. Each resource group switched on gets a tab drawn as the grouped view,
    with its resources side by side in the group's own order - all of them, including any
    switched off on that page: that switch is about a resource being shown on its own, and a
    group is shown whole. A resource switched on that is also in a shown group appears in both:
    its own tab and the group's.

    DaySheetResourceList can leave out resources the order shows - a shown group's hidden
    members, or a resource switched on since - so those are taken from the full resource list
    the order was built from. A resource on the list that the order has never heard of - added
    since the order was last saved - gets a tab at the end rather than going missing.

    With no order to follow, every resource gets a tab in the order it arrived, as it always did.

    The open tab is kept by what it is rather than where it is, so it stays open when the order
    changes around it.
  */
  private buildTabs() {
    const openKey = this.tabs[this.selectedIndex]?.key;
    const resourceTab = (res: any) => ({ kind: "RESOURCE" as const, key: "R" + res.resourceId, name: res.name, resource: res, members: [] });

    this.tabs = (this.ListResources ?? []).map(resourceTab);

    if (this.daysheetOrderItems != null) {
      this.tabs = this.tabsFromOrder(resourceTab);
    }

    const reopen = this.tabs.findIndex(tab => tab.key == openKey);
    this.selectedIndex = reopen >= 0 ? reopen : 0;
  }

  private tabsFromOrder(resourceTab: (res: any) => any): any[] {

    const onSheet = new Map<string, any>();
    this.ListResources.forEach(res => onSheet.set(String(res.resourceId), res));

    const everyResource = new Map<string, any>();
    this.daysheetOrderItems
      .filter(item => item.propertytype == "RESOURCE" && item.resource != null)
      .forEach(item => everyResource.set(item.propertyid, item.resource));

    const known = new Set(this.daysheetOrderItems
      .filter(item => item.propertytype == "RESOURCE")
      .map(item => item.propertyid));

    const tabs: any[] = [];
    const drawn = new Set<string>();

    for (const item of this.daysheetOrderItems) {
      if (!item.showondaysheet) {
        continue;
      }

      if (item.propertytype == "RESOURCE") {
        //Switched on here but left off DaySheetResourceList - the switch on the Daysheet
        //Resource Order page is what decides.
        const res = onSheet.get(item.propertyid) ?? everyResource.get(item.propertyid);

        if (res != null) {
          tabs.push(resourceTab(res));
          drawn.add(item.propertyid);
        }

        continue;
      }

      const members = item.members
        .map(id => onSheet.get(id) ?? everyResource.get(id))
        .filter(res => res != null);

      //A group with nothing in it has nothing to draw.
      if (members.length == 0) {
        continue;
      }

      tabs.push({ kind: "GROUP", key: "G" + item.propertyid, name: item.name, resource: null, members: members });
      members.forEach(res => drawn.add(String(res.resourceId)));
    }

    this.ListResources
      .filter(res => !known.has(String(res.resourceId)) && !drawn.has(String(res.resourceId)))
      .forEach(res => tabs.push(resourceTab(res)));

    return tabs;
  }

  //Resources keep their position across a refresh, so the column they are in is enough.
  trackNormalCell(index: number): number {
    return index;
  }

  trackNormalBooking(index: number, booking: any): string {
    return booking.bookingdata != null ? booking.bookingdata.bookingid : String(index);
  }

  //Without these, a SignalR refresh tears down and rebuilds every block in the grid. Keyed on
  //position, so Angular updates the cells in place instead.
  trackRow(index: number): number {
    return index;
  }

  trackSegment(index: number, seg: any): string {
    return index + "|" + (seg.cell.bookingdata != null ? seg.cell.bookingdata.bookingid : "free") + "|" + seg.span;
  }

  //Consecutive cells holding the same booking become one spanning block. Free cells stay as
  //they were, one small block each.
  buildSegments(row: any[]): any[] {
    let segments: any[] = [];
    let i = 0;

    while (i < row.length) {
      let cell = row[i];

      if (cell.bookingdata == null) {
        segments.push({ cell: cell, span: 1, textColour: this.textColourFor(cell.colour) });
        i++;
        continue;
      }

      let span = 1;

      //index restarts at 0 for the next booking, which is what ends the run.
      while (i + span < row.length
        && row[i + span].bookingdata === cell.bookingdata
        && row[i + span].index !== 0) {
        span++;
      }

      segments.push({ cell: cell, span: span, textColour: this.textColourFor(cell.colour) });
      i += span;
    }

    return segments;
  }

  //Every block has to fit across the screen, so the dot marking the start of a booking is
  //sized from whatever width a block actually ends up with rather than a fixed 10px.
  calculateLayout() {
    if (this.timeArray == null || this.timeArray.length == 0 || this.timeArray[0] == null) {
      return;
    }

    let columns = this.timeArray[0].length;

    if (columns == 0) {
      return;
    }

    let hostWidth = this.daysheetCard != null && this.daysheetCard.nativeElement != null
      ? this.daysheetCard.nativeElement.clientWidth
      : window.innerWidth;

    //The time, used and remaining columns sit either side of the blocks.
    let available = hostWidth - this.fixedColumnsPx;

    if (available < 120) {
      available = 120;
    }

    this.cellWidthPx = available / columns;

    //The column number has to sit inside the block width. A digit is roughly 0.62 of the font
    //size across, so the widest number decides how large the whole row can be.
    let digits = this.columnNumbers.length.toString().length;
    let fitted = (this.cellWidthPx - 2) / (0.62 * digits);

    this.headerFontPx = Math.max(6, Math.min(13, Math.floor(fitted)));
  }

  addMs = (date: Date, ms: number): Date => {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + ms);
    return result;
  };

  viewData(ID) {
    this.thisBooking = this.ListBookings.filter(x => x.bookingId == ID);

    let admissionsText: string = "";
    let extrasText: string = "";

    this.thisBooking[0].resources[0].admissions.forEach(adm => {
      if (adm.noofpeople > 0) admissionsText += adm.noofpeople + " x " + adm.name + ", ";
    });
    if (admissionsText.length > 2) admissionsText = admissionsText.slice(0, -2);

    if (this.thisBooking[0].extras?.length > 0) {
      this.thisBooking[0].extras.forEach(element => {
        if (element.qty > 0) extrasText += element.name + " x " + element.qty + ", ";
      });
    }
    if (extrasText.length > 2) extrasText = extrasText.slice(0, -2);

    let CustomerName = this.thisBooking[0].customer.fullName.trim();
    let FullCustomer = CustomerName;
    const c = this.thisBooking[0].customer;
    if (c.address1) FullCustomer += ", " + c.address1;
    if (c.address2) FullCustomer += ", " + c.address2;
    if (c.townCity) FullCustomer += ", " + c.townCity;
    if (c.postCode) FullCustomer += ", " + c.postCode;

    this.BookingSummary = {
      Disabled: this.thisBooking[0].disabled,
      bookingId: this.thisBooking[0].bookingId,
      bookingIdHR: this.thisBooking[0].bookingIdHR,
      admissions: admissionsText,
      startTime: this.thisBooking[0].startTime,
      endTime: this.thisBooking[0].endTime,
      name: this.thisBooking[0].name,
      arrival: this.thisBooking[0].arrival,
      guests: this.thisBooking[0].guests,
      total: this.thisBooking[0].total,
      outstanding: this.thisBooking[0].outstanding,
      paid: Number(this.thisBooking[0].total) - Number(this.thisBooking[0].outstanding),
      totaldiscounts: Number(this.thisBooking[0].totaldiscounts),
      totalbookingfees: Number(this.thisBooking[0].totalbookingfees ?? this.thisBooking[0].bookingfee ?? 0),
      bookingfee: Number(this.thisBooking[0].bookingfee),
      totalbookingfee: Number(this.thisBooking[0].totalbookingfee ?? 0),
      customerName: this.thisBooking[0].customer.fullName,
      customerAddress: FullCustomer,
      customerMobile: this.thisBooking[0].customer.mobile,
      customerEmail: this.thisBooking[0].customer.email,
      packageName: this.thisBooking[0].packageName,
      publicBooking: this.thisBooking[0].publicBooking,
      extras: extrasText,
      upgrade: this.thisBooking[0].upgrade,
      upgradetext: this.thisBooking[0].upgradetext,
      addontext: this.thisBooking[0].addontext,
      itinerary: this.thisBooking[0].itinerary,
      notes: this.thisBooking[0].notes
    };
  }

  editData(ID) {
    localStorage.setItem("DaysheetDate", this.chosenDate.toJSON());
    localStorage.setItem("FromDaysheet", "TRUE");
    this.router.navigateByUrl("/editbooking/" + ID);
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  //The calendar box picks a date the same way the arrows do, so it resets the scroll too.
  dateSelected() {
    this.hasScrolledToNow = false;
    this.computeNowRow();

    //Without this the live updates stayed on the date shown before, so the sheet kept reloading
    //for bookings on that day and missed the ones on the day now picked.
    this.subscribeToDateHub();
    this.fetchDaysheetData();
  }

  dateChange(num) {
    this.chosenDate = this.addDays(new Date(this.chosenDate), num);
    this.BookingDate = this.chosenDate;

    //Coming back to today should take you to the current time again.
    this.hasScrolledToNow = false;
    this.computeNowRow();

    this.subscribeToDateHub();
    this.fetchDaysheetData();
  }

  bookDateChosen(inDate) {
    let JSONDate = new Date(inDate).toJSON();
    this.router.navigateByUrl("/booking/0?bookingDate=" + JSONDate);
  }
}
